/* eslint-disable camelcase */
import { ICollectionWithProductCards } from '@components/pages/ShopLanding/model/collectionWithProductCards';
import { useTheme } from '@components/theme';
import { useMaxBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { IPrismicImage } from '@lib/prismic/types';
import classNames from 'classnames';
import React from 'react';
import styles from './CollectionWithProducts.module.scss';

const CollectionWithProducts = ({
  ctaLabel,
  image,
  ctaUrl,
  imageTitle
}: Omit<ICollectionWithProductCards, 'vendorVariants'>) => {
  const isMobile = useMaxBreakpoint('tablet');
  const theme = useTheme();

  const getImageUrl = ({ url, mobile_view }: IPrismicImage) => {
    if (isMobile && mobile_view) {
      return mobile_view.url;
    }

    return url;
  };

  return (
    <div className={styles.CollectionWithProducts}>
      <div
        style={{ backgroundImage: `url('${getImageUrl(image)}')` }}
        className={styles.MerchGroupImageWrapper}
      >
        <div className={styles.HeroBackdrop} />
      </div>
      <div className={styles.Content}>
        <h1 className={classNames(
          theme.styles.Title1,
          { [theme.styles.Contrast]: !isMobile },
        )}
        >
          {imageTitle}
        </h1>
        <a
          role="button"
          className={classNames(
            theme.styles.Button,
            { [theme.styles.Conflicting]: !isMobile },
            { [theme.styles.Primary]: isMobile },
          )}
          href={ctaUrl}
          onClick={() => {
            analyticsTrack(`cta_clicked`, {
              title: imageTitle,
              ctaLabel
            });
          }}
        >
          {ctaLabel}
        </a>
      </div>
    </div>
  );
};

export default CollectionWithProducts;
